// App.jsx

import { useEffect, useRef, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

/* COMPONENTS */
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";
import AboutUs from "./components/AboutUs/AboutUs";
import Services from "./components/Services/Services";
import Portfolio from "./components/Portfolio/Portfolio";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

/* PORTFOLIO PAGES */
import Wedding from "./components/Portfolio/Wedding";
import Cinematic from "./components/Portfolio/Cinematic";
import Newbornbaby from "./components/Portfolio/Newbornbaby";
import Maternity from "./components/Portfolio/Maternity";
import Prewedding from "./components/Portfolio/Prewedding";
import Bharatanatyam from "./components/Portfolio/Bharatanatyam";
import Corporate from "./components/Portfolio/Corporate";
/* CONTACT */
import Contact from "./components/Contact/Contact";

/* ADMIN */
import PortfolioAdmin from "./admin/portfolio/PortfolioAdmin";
import AdminLogin from "./admin/AdminLogin";

export default function App() {
  const location = useLocation();
  const isAdmin  = location.pathname === "/admin";

  // ── Auth state — check sessionStorage on load ─────────────
  const [isLoggedIn, setIsLoggedIn] = useState(
    () => sessionStorage.getItem("admin_auth") === "true"
  );

  const handleLogin  = () => setIsLoggedIn(true);
  const handleLogout = () => {
    sessionStorage.removeItem("admin_auth");
    setIsLoggedIn(false);
  };

  // ── Custom cursor ─────────────────────────────────────────
  const dotRef  = useRef(null);
  const ringRef = useRef(null);
  const mx = useRef(0);
  const my = useRef(0);
  const rx = useRef(0);
  const ry = useRef(0);

  useEffect(() => {
    const onMove = (e) => { mx.current = e.clientX; my.current = e.clientY; };
    window.addEventListener("mousemove", onMove);

    let raf;
    const animate = () => {
      rx.current += (mx.current - rx.current) * 0.14;
      ry.current += (my.current - ry.current) * 0.14;
      if (dotRef.current) {
        dotRef.current.style.left = `${mx.current}px`;
        dotRef.current.style.top  = `${my.current}px`;
      }
      if (ringRef.current) {
        ringRef.current.style.left = `${rx.current}px`;
        ringRef.current.style.top  = `${ry.current}px`;
      }
      raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      {/* CURSOR */}
      <div id="cursor-dot"  ref={dotRef}  />
      <div id="cursor-ring" ref={ringRef} />

      <ScrollToTop />

      {/* NAVBAR — hide on admin */}
      {!isAdmin && <Navbar />}

      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/"             element={<Home />} />
        <Route path="/about"        element={<AboutUs />} />
        <Route path="/services"     element={<Services />} />
        <Route path="/portfolio"    element={<Portfolio />} />

        {/* GALLERY PAGES */}
        <Route path="/wedding"      element={<Wedding />} />
        <Route path="/cinematic"    element={<Cinematic />} />
        <Route path="/babyshoot"    element={<Newbornbaby />} />
        <Route path="/maternity"    element={<Maternity />} />
        <Route path="/prewedding"   element={<Prewedding />} />
        <Route path="/bharatanatyam" element={<Bharatanatyam />} />
        <Route path="/corporate"    element={<Corporate />} />
        <Route path="/contact"     element={<Contact />} />

        {/* ADMIN — protected by login */}
        <Route
          path="/admin"
          element={
            isLoggedIn
              ? <PortfolioAdmin onLogout={handleLogout} />
              : <AdminLogin onLogin={handleLogin} />
          }
        />
      </Routes>

      {/* FOOTER — hide on admin */}
      {!isAdmin && <Footer />}
    </>
  );
}